import { intRandom, customRandom } from './_randNum';
import { getRange } from './_getRange';
import { hoverDynamic } from './hover';

export function home() {
  const container = document.querySelector('.js-home-gallery');

  if (container && typeof images_json !== 'undefined') {
    let ww = window.document.documentElement.clientWidth;
    let wh = window.document.documentElement.clientHeight;
    let isAnimate = true;
    let isTransition = false;

    const baseHeight = 1440; // 基準となるウィンドウの幅
  
    const minSize = 10;
    const maxSize = 30;
    const minSizeRatio = 2; // 最小サイズの最小調整率
    const maxSizeRatio = 2; // 最大サイズの最小調整率
    let [adjustedMinSize, adjustedMaxSize] = getRange(minSize, maxSize, '', '', wh, baseHeight, minSizeRatio, maxSizeRatio);
  
    const minSpeed = 1;
    const maxSpeed = 1.5;
    const minSpeedRatio = 0.7; // 最小サイズの最小調整率
    const maxSpeedRatio = 0.7; // 最大サイズの最小調整率
    let [adjustedMinSpeed, adjustedMaxSpeed] = getRange(minSpeed, maxSpeed, '', '', wh, baseHeight, minSpeedRatio, maxSpeedRatio);
  
    const minTiming = 4000;
    const maxTiming = 8000;
    const minTimingLimit = 4000;
    const maxTimingLimit = 10000;
    const minTimingRatio = 0.8; // 最小タイミングの最小調整率
    const maxTimingRatio = 0.6; // 最大タイミングの最小調整率
    let [adjustedMinTiming, adjustedMaxTiming] = getRange(minTiming, maxTiming, minTimingLimit, maxTimingLimit, wh, baseHeight, minTimingRatio, maxTimingRatio);

    const randoms = [];
    const randomsNum = images_json.images.length - 1;
    let current = randomsNum;
    const posts = [];

    const createPost = (currentObj) => {
      const post = document.createElement('a');
      const img = document.createElement('img');
      post.setAttribute('href', currentObj.image_big);
      img.setAttribute('src', currentObj.image);
      img.classList.add('image');
      const posLeft = `${intRandom(-15, 80)}`;
      const zIndex = `${intRandom(0, 100)}`;
      post.style.left = `${posLeft}%`;
      post.style.zIndex = zIndex;
      post.classList.add('post', 'disable-taphold');
      hoverDynamic(post);
      clickPost(post);

      post.style.width = `${intRandom(adjustedMinSize, adjustedMaxSize)}%`;
      post.appendChild(img);
      container.appendChild(post);
      post.setAttribute('data-ratio', customRandom(adjustedMinSpeed, adjustedMaxSpeed, 3))
      posts.push(post);
      
      img.onload = () => {
        post.classList.add('loaded');
        post.setAttribute('data-height', post.clientHeight)
      }
    }

    const clickPost = (post) => {
      post.addEventListener('click', (e) => {
        e.preventDefault();
        if(!isTransition) {
          isTransition = true;
          if(post.classList.contains('is-active')) {
            document.body.classList.remove('is-home-image-zoom');
            post.classList.add('is-hidden')
            const images = post.querySelectorAll('.image');
            if(images.length){
              images.forEach((image) => {
                image.classList.add('is-hidden')
              })
            }
            setTimeout(() => {
              post.classList.remove('is-active');
              posts.forEach((el) => {
                el.classList.remove('is-active', 'is-hidden')
                const els = document.querySelectorAll('.image');
                if(els.length){
                  els.forEach((el) => {
                    setTimeout(() => {
                      el.classList.remove('is-hidden')
                    }, intRandom(0, 2000))
                  })
                }
              })
              isAnimate = true;
              setTimeout(() => {
                isTransition = false;
              }, 2000)
            }, 250);
          } else {
            isAnimate = false;
            isTransition = false;
            document.body.classList.add('is-home-image-zoom');
            const searchValue = post.getAttribute('href')
            const filteredArray = images_json.images.filter(item => item['image_big'] === searchValue);
            posts.forEach((el) => {
              el.classList.remove('is-active');
              el.classList.add('is-hidden')
              const els = el.querySelectorAll('.image');
              if(els.length){
                els.forEach((image) => {
                  image.classList.add('is-hidden')
                })
              }
            });
            setTimeout(() => {
              post.classList.remove('is-hidden')
              post.classList.add('is-active');
              const images = post.querySelectorAll('.image');
              if(images.length){
                images.forEach((_el) => {
                  _el.classList.remove('is-hidden')
                })
              }
            }, 250)
          }
        }
      });
    }

    const animatePosts = () => {
      if(focus && isAnimate) {
        if(posts.length) {
          posts.forEach((post) => {
            const end = 0 + parseFloat(post.getAttribute('data-height'));
            const matrix = new WebKitCSSMatrix(window.getComputedStyle(post).transform);
            const param = matrix.m42 + parseFloat(post.getAttribute('data-ratio'));
            post.style.transform = `translateY(${param}px) translateZ(0)`;

            const postHeight = parseFloat(post.getAttribute('data-height'));
            const fadeStart = wh;
            const fadeEnd = wh + postHeight;
            
            if (param >= fadeStart && param <= fadeEnd) {
              const opacity = 1 - (param - fadeStart) / (fadeEnd - fadeStart);
              post.style.opacity = opacity;
              post.style.filter = `blur(${opacity*1.75}px)`;
            } else if (param > fadeEnd) {
              post.remove();
              const index = posts.indexOf(post);
              if (index > -1) {
                posts.splice(index, 1);
              }
            } else {
              post.style.opacity = 1;
            }

            // if (-param >= end) {
            //   post.remove();
            //   const index = posts.indexOf(post);
            //   if (index > -1) {
            //     posts.splice(index, 1);
            //   }
            // }
          });
        }
      }
      requestAnimationFrame(animatePosts);
    }

    const changeVirtualGallery = (isNext = true) => {
      if (isNext) {
        current = current == randomsNum ? 0 : current + 1;
      } else {
        current = current == 0 ? randomsNum : current - 1;
      }
      const currentObj = images_json.images[randoms[current]];
      createPost(currentObj);
    }

    let lastInnerHeight = window.innerHeight;
    window.addEventListener('resize', () => {
      if(lastInnerHeight != window.innerHeight) {
        lastInnerHeight = window.innerHeight;
        ww = window.document.documentElement.clientWidth;
        wh = window.document.documentElement.clientHeight;
        [adjustedMinSize, adjustedMaxSize] = getRange(minSize, maxSize, '', '', ww, baseHeight, minSizeRatio, maxSizeRatio);
        [adjustedMinSpeed, adjustedMaxSpeed] = getRange(minSpeed, maxSpeed, '', '', wh, baseHeight, minSpeedRatio, maxSpeedRatio);
        [adjustedMinTiming, adjustedMaxTiming] = getRange(minTiming, maxTiming, minTimingLimit, maxTimingLimit, wh, baseHeight, minTimingRatio, maxTimingRatio);
        posts.forEach((post) => {
          post.setAttribute('data-ratio', customRandom(adjustedMinSpeed, adjustedMaxSpeed, 3))
          post.setAttribute('data-height', post.clientHeight)
        })
      }
    })

    let focus = false;
    window.addEventListener('focus', () => {
      focus = true;
    })
    window.addEventListener('blur', () => {
      focus = false;
    })

    const virtualGalleryInit = () => {
      for (let i = 0; i <= randomsNum; i++) {
        let tmp;
        do {
          tmp = intRandom(0, randomsNum);
        } while (randoms.includes(tmp));
        randoms.push(tmp);
      }

      focus = true;
      
      const virtualGalleryCicle = () => {
        if(focus && isAnimate) {
          changeVirtualGallery();
        }
        const int = intRandom(adjustedMinTiming, adjustedMaxTiming)
        setTimeout(virtualGalleryCicle, int);
      }

      document.body.classList.add('is-init-home')
      virtualGalleryCicle();
      animatePosts();
    }

    virtualGalleryInit();
  }
}